module.exports = __webpack_public_path__ + "static/img/tx003.3a2a25c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/service/qualifications/tx003.png
// module id = pJfp
// module chunks = 1